import React, { useState, useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { SlArrowDown } from "react-icons/sl";
import apiClient from "../utils/apiClient";
import { MdOutlineMessage } from 'react-icons/md';
import styled from "styled-components";
import { onlineUsersRoute } from "../utils/APIRoutes";

export default function ContactsMessaged({ setListSet,   markAsRead, socket, contactList, changeChat, showCntcts, currentChat, fetchTraderProducts, setPopDelete }) {
  const navigate = useNavigate();
  const [onlineUsers, setOnlineUsers] = useState([]);
  const [contactLists, setContactLists] = useState([]);
  const [currentUserName, setCurrentUserName] = useState(undefined);
  const [currentUserImage, setCurrentUserImage] = useState(undefined);
  const [currentUserId, setCurrentUserId] = useState(undefined);
  const [currentSelected, setCurrentSelected] = useState(undefined);
  const [closeButton, setCloseButton] = useState(true);

  // Get current user info
  useEffect(() => {
    async function fetchData() {
      const data = await JSON.parse(
        localStorage.getItem(process.env.REACT_APP_LOCALHOST_KEY)
      );
      if (data) {
        setCurrentUserName(data.username);
        setCurrentUserImage(data.avatarImage);
        setCurrentUserId(data._id);
      }
    }
    fetchData();
  }, []);

  // Fetch online users
  //
  // SECURITY: swapped `axios` for `apiClient` — GET /api/online-users
  // now requires an authenticated session on the backend (it used to
  // be callable by anyone, logged in or not, and leaked every online
  // user's email address). A plain axios call wouldn't carry the
  // session cookie, so this would otherwise 401 for every logged-in
  // user too, not just fail closed for anonymous ones.
  //
  // Also gated behind `currentUserId` now (this effect used to fire
  // unconditionally on mount). This component renders for anonymous
  // visitors too (see the `!currentUserName` branch below), and
  // apiClient's shared 401 handler treats any 401 as "session expired"
  // and redirects to /login — so an anonymous visitor loading this
  // component would previously have been incorrectly bounced to the
  // login page just from this fetch failing. Skipping it until a user
  // is actually logged in avoids that, and matches the fact that
  // online-status only has anything to annotate once contactList is
  // populated, which only happens for a logged-in user anyway.
  useEffect(() => {
    if (!currentUserId) return;

    const fetchOnlineUsers = async () => {
      try {
        const onlineUsersData = await apiClient.get(onlineUsersRoute);
        setOnlineUsers(onlineUsersData.data);
      } catch (err) {
        console.error("Error fetching online users:", err.message);
      }
    };
    fetchOnlineUsers();
  }, [currentUserId]);

  // Merge online status into contacts
  useEffect(() => {
    if (contactList.length) {
      const updatedContacts = contactList.map((contact) => ({
        ...contact,
        isOnline: onlineUsers.some((user) => user.userId === contact._id),
      }));
      setContactLists(updatedContacts);
    }
  }, [contactList, onlineUsers]);

  // Handle contact click – select chat (unread count will be reset by parent's fetchMessaged)
  const handleContactClick = async (index, contact) => {
  setCurrentSelected(index);

  changeChat(contact);

  if (markAsRead) {
    await markAsRead(contact._id);
  }
};

  const handleList = () => {
    showCntcts();
    setListSet(false);
    setCloseButton(!closeButton);
  };

  return (
    <>
      {currentUserImage && currentUserName && (
        <Container>
          <div className="current-user" hidden style={{ paddingBottom: '10px' }}>
            <div className="avatar" style={{ display: 'flex', height: '35px', marginTop: 0 }}>
              <Link to={`/traderbrand/${currentUserId}`}>
                {currentUserImage.startsWith("https://") || currentUserImage.includes("https") ? (
                  <img src={currentUserImage} alt={`${currentUserName}'s avatar`} />
                ) : (
                  <img src={`data:image/svg+xml;base64,${currentUserImage}`} alt={`${currentUserName}'s avatar`} />
                )}
              </Link>
              <SlArrowDown onClick={() => setPopDelete(true)} />
            </div>
            <div className="username">
              {currentChat === undefined ? (
                <button onClick={handleList}>
                  <p style={{ fontSize: "12px", display: 'flex', height: "1px", marginTop: "0px" }}><strong>Connect </strong><MdOutlineMessage /></p>
                </button>
              ) : (
                <button onClick={() => fetchTraderProducts(currentUserId)}>{currentUserName.split(" ")[0]}</button>
              )}
            </div>
          </div>

          <div className="contacts">
            {contactLists.length > 0 &&
              contactLists.map((contact, index) => {
                const isSelected = index === currentSelected;
                const unread = contact.unreadCount || 0;

                return (
                  <div
                    key={contact._id}
                    className={`contact ${isSelected ? "selected" : ""}`}
                    onClick={() => handleContactClick(index, contact)}
                  >
                    <div className="avatar">
                      {contact.isOnline && <span className="online-dot"><p style={{ fontSize: '8px', color: 'green', margin: "0" }}>online</p></span>}
                      
                      {/* ✅ Unread count badge (shows number, hidden when 0) */}
                      {unread > 0 && (
                        <span className="unread-badge">{unread}</span>
                      )}

                      {contact.avatarImage ? (
                        <>
                          {contact.avatarImage.startsWith("https://") || contact.avatarImage.includes("https") ? (
                            <img src={contact.avatarImage} alt={`${contact.username}'s avatar`} />
                          ) : (
                            <img src={`data:image/svg+xml;base64,${contact.avatarImage}`} alt={`${contact.username}'s avatar`} />
                          )}
                        </>
                      ) : (
                        <img
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAIAAADTED8xAAADMElEQVR4nOzVwQnAIBQFQYXff81RUkQCOyDj1YOPnbXWPmeTRef+/3O/OyBjzh3CD95BfqICMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMK0CMO0TAAD//2Anhf4QtqobAAAAAElFTkSuQmCC"
                          alt="Default Avatar"
                        />
                      )}
                      <div className="username-overlay">
                        <b><p style={{ margin: 0 }}>{contact.username.split(" ")[0]}</p></b>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </Container>
      )}

      {!currentUserName && (
        <UnauthenticatedChatButton>
          <div className="left-col">
            <button onClick={() => navigate('/login')}>
              Chat <MdOutlineMessage />
            </button>
          </div>

          <div className="center-col">
            <Link to="/unboxing" className="unboxing">
              Surprise Unboxing
            </Link>
            <Link to="/login" className="login">
              Login
            </Link>
          </div>

          <div className="right-col">
            <Link to="/privacy-policy" className="privacy">
              Privacy Policy
            </Link>
            <Link to="/login" className="signup">
              SignUp
            </Link>
          </div>
        </UnauthenticatedChatButton>
      )}
    </>
  );
}

const Container = styled.div`
  display: flex;
  grid-template-rows: 10% 75% 15%;
  overflow: hidden;
  background-color: #f0f0f0;
  border-radius: 5px;
  margin-top: 0rem;
  .brand {
    display: flex;
    align-items: center;
    gap: 2rem;
    width: 100%;
    justify-content: center;
    img {
      height: 2rem;
    }
    h3 {
      color: white;
    }
  }
  .contacts {
    display: flex;
    flex-direction: row;
    align-items: center;
    overflow-x: scroll;
    z-index: 1;
    gap: 0;
    &::-webkit-scrollbar {
      width: none;
      display: none;
      &-thumb {
        background-color: #f0f0f0;
        width: 0.1rem;
        border-radius: 1rem;
      }
    }
    .contact {
      background-color: #ffffff34;
      min-height: 3rem;
      cursor: pointer;
      width: 90%;
      border-radius: 0.2rem;
      padding: 0.4rem;
      display: flex;
      flex-direction: row;
      gap: 0;
      align-items: center;
      transition: 0.5s ease-in-out;
      .avatar {
        position: relative;
        img {
          height: 2rem;
        }

        /* ✅ Unread count badge (number) */
        .unread-badge {
          position: absolute;
          top: -4px;
          right: -4px;
          background-color: #ff4757;
          color: white;
          border-radius: 50%;
          padding: 1px 5px;
          font-size: 10px;
          font-weight: bold;
          min-width: 16px;
          text-align: center;
          border: 2px solid white;
          z-index: 10;
          animation: pulse 1.5s infinite;
        }

        .username-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(0, 0, 0, 0.5);
          color: white;
          text-align: center;
          padding: 2px;
          font-size: 12px;
        }
      }
      .username {
        h4 {
          color: black;
        }
      }
    }
  }

  .current-user {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: left;
    z-index: 10;
    .avatar {
      img {
        height: 3rem;
        max-inline-size: 100%;
      }
    }
    .username {
      h3 {
        color: black;
      }
    }
    @media screen and (min-width: 720px) and (max-width: 1080px) {
      gap: 0.5rem;
      .username {
        h2 {
          font-size: 1rem;
        }
      }
    }
  }
  @keyframes pulse {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 71, 87, 0.7);
    }
    70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(255, 71, 87, 0);
    }
    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(255, 71, 87, 0);
    }
  }
`;

const UnauthenticatedChatButton = styled.div`
  display: grid;
  grid-template-columns: 25% 1fr 25%;
  margin-top: 0.5rem;
  min-height: 150px;
  background-color: #f0f0f0;

  .left-col {
    width:25%;
    height:25%;
    display: flex;
    justify-content: center;
    align-items: center;
    button {
      margin-left:35px;
      background-color: white;
      color: #0056b3;
      box-shadow: 0 4px 18px rgba(0, 0, 0, 0.12);
      border: none;
      padding: 0.5rem 1rem;
      border-radius: 5px;
      cursor: pointer;
      font-size: 1rem;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      &:hover {
        background-color: #007bff;
      }
    }
  }

  .center-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 0.8rem;
    .unboxing, .login {
      text-decoration: none;
      font-size: 14px;
      color: linear-gradient(135deg, #000000 0%, #1a1a1a 35%, #2b2b2b 50%, #111111 75%, #000000 100%);
    }
  }

  .right-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 0.2rem;
    .privacy, .signup {
      text-decoration: none;
      font-size: 14px;
      color: linear-gradient(135deg, #000000 0%, #1a1a1a 35%, #2b2b2b 50%, #111111 75%, #000000 100%);    }
    .signup {
      background-color: white;
      padding: 6px 12px;
      border-radius: 4px;
      font-weight: bold;
      box-shadow: 0 4px 18px rgba(0, 0, 0, 0.12);
      color:linear-gradient(135deg, #000000 0%, #1a1a1a 35%, #2b2b2b 50%, #111111 75%, #000000 100%);
      margin-bottom: 50px;
    }
  }
`;
